import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { WhatsAppIcon } from '../../assets/icons';

const WhatsAppButton = ({
  phoneNumber,
  className = "",
  size = "sm"
}) => {
  const { t } = useLanguage();

  const formatPhoneNumberForWhatsApp = (phoneNumber) => {
    // Remove any non-digit characters except +
    let cleaned = phoneNumber.replace(/[^\d+]/g, '');

    // If it starts with +, keep it, otherwise add +
    if (!cleaned.startsWith('+')) {
      cleaned = '+' + cleaned;
    }

    return cleaned;
  };

  const handleWhatsAppClick = () => {
    if (!phoneNumber) return;

    const formattedNumber = formatPhoneNumberForWhatsApp(phoneNumber);
    const whatsappUrl = `https://wa.me/${formattedNumber}`;

    // Open in new tab
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base"
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      disabled={!phoneNumber}
      className={`inline-flex items-center gap-1.5 border border-transparent font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ${sizeClasses[size]} ${className}`}
      title={phoneNumber ? t('conversationActivities.openWhatsApp') : t('conversationActivities.noPhoneNumber')}
    >
      <WhatsAppIcon className="w-4 h-4" />
      {/* <span>{t('conversationActivities.whatsapp')}</span> */}
    </button>
  );
};

export default WhatsAppButton;
